import styled from "@emotion/styled"

const ArticleAsideBlogPostTitle = styled.h3`
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 0;

  ${({ theme }) => theme.breakpoints.down("2xl")} {
    font-size: 20px;
    line-height: 25px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    font-size: 24px;
    line-height: 30px;
  }
`

export default ArticleAsideBlogPostTitle
